import React from "react";
import { Helmet } from "react-helmet-async";

const title = "Disclaimer | Shivam Shipping & Logistics";
const description =
  "Read the official Disclaimer of Shivam Shipping & Logistics. Understand our policies, responsibilities, and terms regarding services offered.";
const keywords =
  "disclaimer, Shivam Shipping & Logistics, terms and conditions, service policies, maritime logistics, cargo handling, ship agency";
const ogImage = "";
const canonical = "https://shivamshippingandlogistics-scm.com/Legal/disclaimer";

const Disclaimer = () => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Shivam Shipping & Logistics" />
        <meta name="language" content="en" />
        <meta name="distribution" content="global" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        {/* Canonical Link */}
        <link rel="canonical" href={canonical} />
      </Helmet>
      <div className="disclaimer px-5 mt-6 text-black mx-4">
        <h1 className="text-center text-2xl py-10 font-bold"> DISCLAIMER </h1>
        Last updated: 2024-01-01
        <br />
        <br />
        <a className="text-lg font-medium ">WEBSITE DISCLAIMER</a>
        <br />
        The information provided by Shivam Shipping & Logistics (“Company”, “we”,
        “our”, “us”) on https://shivamshippingandlogistics-scm.com (the “Site”) is for general
        informational purposes only. All information on the Site is provided in
        good faith, however we make no representation or warranty of any kind,
        express or implied, regarding the accuracy, adequacy, validity,
        reliability, availability, or completeness of any information on the
        Site. UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY
        LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE
        OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE. YOUR USE OF THE
        SITE AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE IS SOLELY AT YOUR
        OWN RISK.
        <br />
        <a className="text-lg font-medium">EXTERNAL LINKS DISCLAIMER</a>
        <br />
        The Site may contain (or you may be sent through the Site) links to
        other websites or content belonging to or originating from third parties
        or links to websites and features. Such external links are not
        investigated, monitored, or checked for accuracy, adequacy, validity,
        reliability, availability or completeness by us.
        WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR THE
        ACCURACY OR RELIABILITY OF ANY INFORMATION OFFERED BY THIRD-PARTY
        WEBSITES LINKED THROUGH THE SITE OR ANY WEBSITE OR FEATURE LINKED IN ANY
        BANNER OR OTHER ADVERTISING. WE WILL NOT BE A PARTY TO OR IN ANY WAY BE
        RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY
        PROVIDERS OF PRODUCTS OR SERVICES.
        <br />
        <a className="text-lg font-medium">PROFESSIONAL DISCLAIMER</a>
        <br />
        The Site can not and does not contain legal or financial advice. The information
        is provided for general informational and educational purposes only and
        is not a substitute for professional advice. Accordingly,
        before taking any actions based upon such information, we encourage you
        to consult with the appropriate professionals. Content published on
        https://shivamshippingandlogistics-scm.com is intended to be used and must be used for
        informational purposes only. It is very important to do your own
        analysis before making any decision based on your own personal
        circumstances. You should take independent professional advice from a
        specialist or independently research and verify any information that
        you find on our Website and wish to rely upon. THE USE OR RELIANCE OF
        ANY INFORMATION CONTAINED ON THIS SITE IS SOLELY AT YOUR OWN RISK.
        <br />
        <a className="text-lg font-medium">TESTIMONIALS DISCLAIMER</a>
        <br />
        The Site may contain testimonials by users of our products and/or
        services. These testimonials reflect the real-life experiences and
        opinions of such users. However, the experiences are personal to those
        particular users, and may not necessarily be representative of all users
        of our products and/or services. We do not claim, and you should not
        assume that all users will have the same experiences.
        <br />
        <a className="text-lg font-medium">YOUR INDIVIDUAL RESULTS MAY VARY.</a>
        <br />
        The testimonials on the Site are submitted in various forms such as
        text, audio and/or video, and are reviewed by us before being posted.
        They appear on the Site verbatim as given by the users, except for the
        correction of grammar or typing errors. Some testimonials may have been
        shortened for the sake of brevity, where the full testimonial contained
        extraneous information not relevant to the general public. The views and
        opinions contained in the testimonials belong solely to the individual
        user and do not reflect our views and opinions.
        <br />
        <a className="text-lg font-medium">ERRORS AND OMISSIONS DISCLAIMER</a>
        <br />
        While we have made every attempt to ensure that the information
        contained in this site has been obtained from reliable sources,
        Shivam Shipping & Logistics is not responsible for any errors or omissions
        or for the results obtained from the use of this information. All
        information in this site is provided “as is”, with no guarantee of
        completeness, accuracy, timeliness or of the results obtained from the
        use of this information, and without warranty of any kind, express or
        implied, including, but not limited to warranties of performance,
        merchantability, and fitness for a particular purpose. In no event will
        Shivam Shipping & Logistics, its related partnerships or corporations, or
        the partners, agents or employees thereof be liable to you or anyone
        else for any decision made or action taken in reliance on the
        information in this Site or for any consequential, special or similar
        damages, even if advised of the possibility of such damages.
        <br />
        <a className="text-lg font-medium">LOGOS AND TRADEMARKS DISCLAIMER</a>
        <br />
        All logos and trademarks of third parties referenced on
        https://shivamshippingandlogistics-scm.com are the trademarks and logos of their
        respective owners. Any inclusion of such trademarks or logos does not
        imply or constitute any approval, endorsement or sponsorship of
        Shivam Shipping & Logistics by such owners.
        <br />
        <a className="text-lg font-medium">CONTACT US</a>
        <br />
        Should you have any feedback, comments, requests for technical support
        or other inquiries, please contact us by email:
        business@sslscm.com. This Disclaimer was created for
        https://shivamshippingandlogistics-scm.com on 2024-01-01.
      </div>
    </>
  );
};

export default Disclaimer;
